import { render, staticRenderFns } from "./AutomaticEvents.vue?vue&type=template&id=868a098e"
import script from "./AutomaticEvents.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomaticEvents.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AutomaticEvents.vue?vue&type=style&index=0&id=868a098e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports